module.exports = __webpack_public_path__ + "img/5.791c9bb4.png";